import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { Container } from '@/components/ui/Container';
import { Icon } from '@/components/ui/Icon';
import { Label } from '@/components/ui/Label';
import { Signature } from '@/components/ui/Signature';
import { footerNavigation, site, socialHref, socials } from '@/content/site';

import { FooterCircuit } from './Circuits';

const year = 2026;

const LINK = 'inline-flex items-center gap-2.5 text-body-s text-blanc no-underline hover:underline';

/** Pied de page encre, nappe de pistes en fond (maquette). */
export function Footer() {
  return (
    <footer className="relative z-10 overflow-hidden bg-encre pt-22 pb-10 text-blanc">
      <FooterCircuit />

      <Container className="relative">
        <div className="grid gap-10 pb-12 tab:grid-cols-2 desk:grid-cols-[minmax(0,1.4fr)_repeat(3,minmax(0,1fr))]">
          <div>
            <Signature />
            <p className="mt-4.5 max-w-[22em] text-body-xs text-blanc/72">{site.pitch}</p>
          </div>

          <FooterColumn title="Naviguer">
            {footerNavigation.map((item) => (
              <li key={item.to}>
                <Link to={item.to} className={LINK}>
                  {item.label}
                </Link>
              </li>
            ))}
          </FooterColumn>

          <FooterColumn title="Suivre">
            {socials.map((social) => (
              <li key={social.id}>
                <a href={socialHref(social)} className={LINK}>
                  <Icon name={social.icon} size={16} />
                  {social.label}
                </a>
              </li>
            ))}
          </FooterColumn>

          <FooterColumn title="Contact">
            <li>
              <Link to="/a-propos#contact" className={LINK}>
                <Icon name="mail" size={16} />
                Me contacter
              </Link>
            </li>
          </FooterColumn>
        </div>

        <div className="border-t border-blanc/14 pt-6">
          <Label tone="clair">
            © {year} {site.name}
          </Label>
        </div>
      </Container>
    </footer>
  );
}

function FooterColumn({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div>
      <Label as="h4" tone="clair" className="mb-3.5">
        {title}
      </Label>
      <ul className="m-0 grid list-none gap-2.5 p-0">{children}</ul>
    </div>
  );
}
